import React from 'react'
import copywriting from 'copywriting'
import { useMatch, useLocation } from 'react-router-dom'
import { useIntl } from 'react-intl'
import { useBrand } from 'contexts/BrandContext'
import { rebrandText } from 'brands/rebrand'

export const MarkdownCopy = ({ id, children, ...props }) => {
  const { pathname } = useLocation()
  const match = useMatch(pathname)
  const { locale } = useIntl()
  const brand = useBrand()

  // The landing copy is written for VoiceArchive; a brand rewrites its name and links.
  const __html = rebrandText(brand, copywriting(locale, match.pathname, id))

  if (!__html) {
    return children ? <p {...props}>{children}</p> : null
  }

  // className "prose" comes from @tailwindcss/typography and styles inner HTML tags like <h1>, <p>, etc.
  // Mostly used for HTML rendered from Markdown, or pulled from a CMS
  // https://www.npmjs.com/package/@tailwindcss/typography

  return (
    <div className="prose max-w-none">
      <div dangerouslySetInnerHTML={{ __html }} {...props} />
    </div>
  )
  
}

export default MarkdownCopy
